import jQuery from "jquery";
import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";
import {ZIDXBase} from "../../../standalone/base.js";
const $ = jQuery.noConflict();

export class ZIDXAccountOfficeLookup implements ZIDXPage {
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }

    getPageClass() {
        return "zidxAccountOfficeLookupContainer";
    }


    render() {
        // console.log("site edit");
        let lookupTimeoutId:number|NodeJS.Timeout=0;
        let self=this;
        $("#lookup_text", this.zidx.peakidxShadowRoot).on("input", function(this:HTMLInputElement){
            // collapse whitespace so the server never receives empty words
            let lookupText=this.value.trim().replace(/\s+/g, " ");
            clearTimeout(lookupTimeoutId);
            if(lookupText.length<3){
                $("#lookup_results", self.zidx.peakidxShadowRoot).html("");
                return;
            }
            let field=this.getAttribute("data-field");
            let fieldElement=$("#"+field, window.parent.document)[0] as HTMLInputElement;
            let listing_index_id=this.getAttribute("data-index-id");
            lookupTimeoutId=setTimeout(function() {
                let obj = {
                    id: "ajaxOfficeLookup",
                    method: "get",
                    postObj: {},
                    ignoreOldRequests: true,
                    callback: function (r: string) {
                        let js: any = JSON.parse(r);
                        // console.log(js);
                        let resultsElement=$("#lookup_results", self.zidx.peakidxShadowRoot);
                        resultsElement.html("");
                        if (js.success) {
                            let arrLine = js.data.split("\\n");
                            resultsElement.append('<p>Select one of the offices below to add to the list. Results are limited to the top 50 matches.</p>');
                            for (let i = 0; i < arrLine.length; i++) {
                                if(arrLine[i].trim().length==0) continue;
                                let arrRow = arrLine[i].split("\\t");
                                let officeName = arrRow[0];
                                let officeId = arrRow[1];
                                // console.log(officeName, officeId);
                                let link=document.createElement("a");
                                link.onclick=function(){
                                    let ids=fieldElement.value.split(",");
                                    if(fieldElement.value.trim()==""){
                                        ids=[];
                                    }
                                    if(ids.indexOf(officeId)==-1){
                                        ids.push(officeId);
                                        fieldElement.value=ids.join(",");
                                    }else{
                                        alert("Already added this office");
                                    }
                                    // @ts-ignore
                                    window.parent.zidxCloseAllModalWindows();
                                }
                                link.style.backgroundColor="rgba(128,128,128, .1)";
                                link.style.color="var(--text-color)";
                                link.style.padding="5px";
                                link.style.cursor="pointer";
                                link.title="Click to add this office to the list";
                                link.style.margin="5px";
                                link.style.borderRadius="5px";
                                link.style.display="inline-block";
                                link.style.minWidth="300px";
                                link.style.width="45%";
                                link.textContent=ZIDXBase.firstLetterCaps(officeName);
                                resultsElement.append(link);
                            }
                        }
                    },
                    errorCallback: function (e: XMLHttpRequest) {
                        console.log(e.status);
                    },
                    url: '/account/sites/office-lookup/search?listing_index_id=' + encodeURIComponent(listing_index_id||"") + '&lookupText=' + encodeURIComponent(lookupText)
                };
                self.zidx.ajaxRequest(obj);
            }, 250);
        });
    }
}